import React from 'react'
import LoadIndicator from 'devextreme-react/load-indicator'

export const DropDownButtonRender = (loading) => () => (
    <div
        style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            cursor: 'pointer',
        }}>
        {/* DevExtreme SelectBox uses the "spindown" icon for dropdown affordance. */}
        <i className='dx-icon dx-icon-spindown' style={{ opacity: loading ? 0.5 : 1 }} />
        {loading ? (
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <LoadIndicator visible={true} />
            </div>
        ) : null}
    </div>
)
